import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pageView } from "../lib/analytics";

export function usePageViewTracking(): void {
  const { pathname } = useLocation();

  useEffect(() => {
    pageView(pathname, document.title);
  }, [pathname]);
}
